import { initGraphQLTada } from 'gql.tada'

import type { Scalars } from '@isoapp/common/platform/types/scalars/scalars'

import type { introspection } from '#@__generated/graphql/graph'

export const graphql = initGraphQLTada<{
  introspection: introspection
  scalars: Scalars
}>()
